import { createContext, useContext } from 'react';

import { Maybe } from 'types/UtilityTypes';

import type { SharepointWorkbookRowsResponse } from '../types/SharepointWorkbookRows';

export type SharepointLoadBuildingGraphState = {
  /** Last successful v2 `POST /sharepoint/workbooks/load-suggestions` payload. */
  workbookRowsResponse: Maybe<SharepointWorkbookRowsResponse>;
  /** Derived from {@link workbookRowsResponse} for callers that only need sheet metadata. */
  graphMeta: Maybe<
    Pick<
      SharepointWorkbookRowsResponse,
      'fileName' | 'worksheetName' | 'rowCount' | 'columnCount'
    >
  >;
  /**
   * Drops in-memory worksheet cache and re-fetches Graph rows for the host workbook (e.g. after
   * editing workbook cells or after successful write-back). No-op when not on a SharePoint workbook tab.
   */
  refreshGraphRowsBypassCache?: () => void;
};

export const defaultGraphState: SharepointLoadBuildingGraphState = {
  workbookRowsResponse: null,
  graphMeta: null,
  refreshGraphRowsBypassCache: undefined,
};

export const SharepointLoadBuildingGraphContext =
  createContext<SharepointLoadBuildingGraphState>(defaultGraphState);

export function useSharepointLoadBuildingGraphState(): SharepointLoadBuildingGraphState {
  return useContext(SharepointLoadBuildingGraphContext);
}
